<div class="link-wrapper">
  <div class="copy-button" [class.copied]="copied" #shareLinkRef>
    <span
    [ngxClipboard]
    [cbContent]="classroomUrl"
    (cbOnSuccess)="onCopied()"
    [container]="shareLinkRef">
      <span class="copy-button-message">
        {{ 'classrooms.invite.copied' | translate }}
      </span>

      <span class="copy-button-link">
        {{ 'classrooms.invite.copy-link' | translate }} <app-icon icon="copy-link" width="12" height="12"></app-icon>
      </span>
    </span>
  </div>
</div>

